'use client';

import * as Sentry from '@sentry/nextjs';

export function getCountryName(countryCode: string) {
  try {
    const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
    return (
      regionNames
        ?.of(countryCode)
        ?.normalize('NFD')
        ?.replace(/[\u0300-\u036f]/g, '') || countryCode
    );
  } catch (error) {
    Sentry.captureException(error);
    return countryCode;
  }
}
